"use client";

import { useEffect, useRef } from "react";
import "../asstes/styles/PrivateAnimation.scss";
import animationImage1 from "../asstes/images/private-council/animationImage1.jpg";
import animationImage2 from "../asstes/images/private-council/animationImage2.jpg";
import animationImage3 from "../asstes/images/private-council/animationImage3.jpg";
import animationImage4 from "../asstes/images/private-council/animationImage4.jpg";
import { Card, Col, Row } from "react-bootstrap";
import MagneticText from "./MagneticText";
export default function PrivateAnimation() {
  const refs = useRef([]);
  const containerRef = useRef(null);
  const IMAGE_LAYOUT = [
    {
      src: animationImage1,
      width: 300,
      height: 300,
      center: true, 
    },
    {
      src: animationImage2,
      offsetX: 0,
      offsetY: -200,
      width: 500,
      height: 180,
    },
    {
      src: animationImage4,
      offsetX: 330,
      offsetY: 0,
      width: 170,
      height: 500,
    },
    {
      src: animationImage3,
      offsetX: 0,
      offsetY: 330, 
      width: 300,
      height: 170,
    },
  ];
  // const IMAGE_LAYOUT = [
  //   {
  //     src: animationImage1,
  //     width: 300,
  //     height: 300,
  //   },
  //   {
  //     src: animationImage2,
  //     left: 160,
  //     top: 10,
  //     width: 500,
  //     height: 160,
  //   },

  //   {
  //     src: animationImage4,
  //     left: 480,
  //     top: 180,
  //     width: 170,
  //     height: 450,
  //   },
  //   {
  //     src: animationImage3,
  //     left: 160,
  //     top: 500,
  //     width: 300,
  //     height: 170,
  //   },
  // ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        const stage = containerRef.current.querySelector(".stage");
        const stageRect = stage.getBoundingClientRect();

        const centerCfg = IMAGE_LAYOUT[0];
        const centerX = stageRect.width / 2 - centerCfg.width / 2;
        const centerY = stageRect.height / 2 - centerCfg.height / 2;

        refs.current.forEach((el, i) => {
          if (!el) return;

          const cfg = IMAGE_LAYOUT[i];
          const delay = i * 120;

          // Initial state (collapsed at center)
          el.style.transition = "none";
          el.style.width = cfg.width + "px";
          el.style.height = cfg.height + "px";
          el.style.left = centerX + "px";
          el.style.top = centerY + "px";
          el.style.opacity = i === 0 ? "1" : "0";
          el.style.transform = "scale(0.6)";

          setTimeout(() => {
            el.style.transition = `all 0.8s cubic-bezier(0.34,1.56,0.64,1) ${delay}ms`;

            if (cfg.center) {
              // CENTER IMAGE
              el.style.left = centerX + "px";
              el.style.top = centerY + "px";
              el.style.zIndex = 2;
            } else {
              // OUTSIDE / RELATIVE IMAGES
              el.style.left = centerX + (cfg.offsetX || 0) + "px";
              el.style.top = centerY + (cfg.offsetY || 0) + "px";
              el.style.zIndex = 1;
            }

            el.style.opacity = "1";
            el.style.transform = "scale(1)";
          }, 100);
        });
      },
      { threshold: 0.4 },
    );

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="wrap" ref={containerRef}>
      <div className="layout">
        <Row className="justify-content-start mt-4">
          {/* <MagneticText
  as="h5"
  className="animated-title text-uppercase mb-3"
>
  When the Moment Arrives
</MagneticText> */}
          <h5 className="animated-title text-uppercase mb-3">
            When the Moment Arrives
          </h5>
          <Col md={8} style={{ width: "92%" }}>
            <div
              className="border-0"
              style={{
                background: "rgba(255,255,255,0.02)",
                border: "1px solid rgba(201,168,76,0.18)",
                borderRadius: "4px",
              }}
            >
              <div className="">
                <ul className="list-unstyled mb-0" style={{ width: "100%" }}>
                  <li className="d-flex align-items-start mb-3">
                    <span
                      className="me-3"
                      style={{
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#C9A84C",
                        borderRadius: "50%",
                        marginTop: "8px",
                        flexShrink: 0,
                      }}
                    />
                    <p className="mb-0 text-light fs-6">
                      <MagneticText>
                        This is the moment where hesitation ends and consequence
                        begins.
                      </MagneticText>
                    </p>
                    {/* <p className="mb-0 text-light fs-6">
              <strong>This is the moment</strong> where hesitation ends and consequence begins.
            </p> */}
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <span
                      className="me-3"
                      style={{
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#C9A84C",
                        borderRadius: "50%",
                        marginTop: "8px",
                        flexShrink: 0,
                      }}
                    />
                    <p className="mb-0 text-light fs-6">
                      <MagneticText>
                        When the decision cannot wait, clarity must arrive.
                      </MagneticText>
                    </p>
                    {/* <p className="mb-0 text-light fs-6">
              When the decision cannot wait, <strong>clarity must arrive</strong>.
            </p> */}
                  </li>

                  <li className="d-flex align-items-start">
                    <span
                      className="me-3"
                      style={{
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#C9A84C",
                        borderRadius: "50%",
                        marginTop: "8px",
                        flexShrink: 0,
                      }}
                    />
                    <p className="mb-0 text-light fs-6">
                      <MagneticText>
                        Not guidance. Not reassurance. A reckoning.
                      </MagneticText>
                    </p>
                    {/* <p className="mb-0 text-light fs-6">
              <strong>Not guidance.</strong> <strong>Not reassurance.</strong> A reckoning.
            </p> */}
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
        {/* RIGHT IMAGES */}
        <div className="stage">
          {IMAGE_LAYOUT.map((item, i) => (
            <div key={i} ref={(el) => (refs.current[i] = el)} className="photo">
              <img src={item.src} alt="lorem" />
            </div>
          ))}
        </div>
        {/* <div className="stage">
          {[animationImage1,animationImage2, animationImage3, animationImage4,animationImage1,animationImage2].map((image, i) => (
            <div
              key={i}
              ref={el => (refs.current[i] = el)}
              className={`photo ${i === 0 ? "center" : ""}`}
            >
            <img
  src={image}
  alt="lorem"
/>
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );
}
